export default "__VITE_ASSET__Djk_d$Cm__"